
export const locale = {
  'ATTACHMENT' : {
    'DROP_LABEL' : 'Перетащите документы, чтобы прикрепить или щелкните, чтобы выбрать',
    'DROP_LABEL_DISABLED' : 'Нет прикрепленных файлов',
  }
};
